import { Injectable } from "@angular/core";
import { Settings } from "./app.settings.model";

@Injectable()
export class AppSettings
{
  public settings = new Settings({
    name: "",
    loadingSpinner: false,
    fixedHeader: true,
    fixedSidenav: true,
    fixedSidenavUserContent: false,
    fixedFooter: false,
    sidenavIsOpened: true,
    sidenavIsPinned: true,
    menu: "vertical",
    menuType: "default",
    theme: "teal-light",
    rtl: false
  });

  public themes = ['teal-light', 'teal-dark', 'slate-light', 'slate-dark', 'pink-light', 'pink-dark', 'purple-light', 'purple-dark', 'blue-light', 'blue-dark', 'drk-blue-light', 'drk-blue-dark', 'drk-green-light', 'drk-green-dark', 'drk-red-light', 'drk-red-dark', 'red-light', 'red-dark', 'green-light', 'green-dark', 'brown-light', 'brown-dark', 'gold-light', 'gold-dark', 'orange-light', 'orange-dark']

  public company: string;
}
